














































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import RechargeCardApi from '@/api/marketing/rechargeCoupon/index'
import AbpBase from '@/lib/abpbase'
import PicModal from '@/components/upload/picModal.vue'
import CustomForm from '@/components/custom-form/index.vue'
import CouponApi from '@/api/marketing/coupon/index'
@Component({
  components: {
    PicModal,
    CustomForm,
  },
})
export default class RechargeCardCouponEdit extends AbpBase {
  currentTab: string = 'basicForm'
  activityId: string = ''
  addrecharge: boolean = false
  isShowSelectProductModal: boolean = false
  automaticCardModal: boolean = false
  totalCount: number = 0
  pageSize: number = 10
  pageIndex: number = 1
  loading: boolean = false
  autoInputValue: number = null
  selectedItems: any = []
  page: any = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
  }
  selectedProdcutColumns: any[] = [
    {
      title: '优惠券名称',
      key: 'name',
      align: 'center',
    },
    {
      title: '数量',
      key: 'count',
      align: 'center',
      render: (h, params) => {
        return h('InputNumber', {
          props: {
            value: this.getProductList()[params.index].count,
            min: 1,
          },
          on: {
            'on-change': (event) => {
              this.getProductList()[params.index].count = event
            },
          },
        })
      },
    },
    {
      title: '操作',
      slot: 'action',
      width: 150,
      align: 'center',
    },
  ]
  productFilters: any[] = [
    {
      label: '输入搜索：',
      type: 'input',
      props: {
        placeholder: '请输入优惠券名称',
      },
      key: 'keyWord',
    },
  ]
  productColumns: any[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '优惠券名称',
      key: 'name',
      align: 'center',
    },
    {
      title: '优惠券类型',
      key: 'couponTypeDisplayName',
      align: 'center',
    },
    {
      title: '有效期',
      key: 'validDate',
      align: 'center',
    },
    // {
    //   title: '操作',
    //   slot: 'action',
    //   align: 'center',
    // },
  ]
  productData: any[] = []
  columns: any[] = [
    // {
    //   title: '卡号',
    //   key: 'name',
    //   align: 'center',
    // },
    {
      title: '密码',
      key: 'value',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      width: 150,
      align: 'center',
    },
  ]
  addRechargeText: string = ''
  formItem = {
    name: '',
    code: '',
    beginTime: null,
    endTime: null,
    isPublish: false,
    items: [],
    rechargeableCoupons: [],
  }
  ruleValidate = {
    name: [{ required: true, message: '活动标题不能为空', trigger: 'blur' }],
    code: [{ required: true, message: '编码不能为空', trigger: 'blur' }],
    // amount: [{ required: true, message: '面额不能为空', trigger: 'blur' }],
    beginTime: [
      {
        required: true,
        validator: this.validBeginTime,
        trigger: 'change',
      },
    ],
    endTime: [
      {
        required: true,
        validator: this.validEndTime,
        trigger: 'change',
      },
    ],
  }
  validBeginTime(rule, value, callback) {
    if (value == '' || !value) {
      callback(new Error('请选择开始日期'))
    } else {
      ;(this.$refs as any).basicForm.validateField('endTime')
    }
    callback()
  }
  deleteRecharge(index) {
    this.formItem.items.splice(index, 1)
  }
  validEndTime(rule, value, callback) {
    if (value === '' || !value) {
      callback(new Error('请选择结束日期'))
    }
    if (value < this.formItem.beginTime) {
      callback(new Error('结束日期必须大于开始日期'))
    }
    callback()
  }
  cancelFn() {
    this.addrecharge = false
    this.addRechargeText = ''
  }
  saveFn() {
    if (this.addRechargeText.trim() == '') {
      this.$Notice.warning({
        title: '卡密输入不能为空',
      })
      return
    }
    let arr = this.addRechargeText.split(/[(\r\n)\r\n]+/)
    let arr1 = []
    if (arr.length) {
      arr1 = arr.map((item) => {
        return {
          name: item.split(' ')[0],
          value: item.split(' ')[1],
        }
      })
    }
    console.log(arr1)
    this.formItem.items = this.removal(this.formItem.items.concat(arr1))
    this.addrecharge = false
    this.addRechargeText = ''
  }
  saveAutoFn() {
    if (!this.autoInputValue) {
      this.$Notice.warning({
        title: '生成的卡密条数不能为空',
      })
      return
    }
    RechargeCardApi.autoGenerate(this.autoInputValue).then((res) => {
      console.log('自动卡密', res)
      this.$Notice.success({
        title: '生成成功',
      })
      this.automaticCardModal = false
      this.autoInputValue = null
      this.formItem.items = this.removal(this.formItem.items.concat(res.data.items))
    })
  }
  removal(arr) {
    for (let i = 0; i < arr.length; i++) {
      for (let j = i + 1; j < arr.length; j++) {
        if (arr[i].name == arr[j].name && arr[i].value == arr[j].value) {
          arr.splice(j, 1)
          j--
        }
      }
    }
    return arr
  }
  async onPageChange(pageIndex: number) {
    this.pageIndex = pageIndex
  }
  save() {
    var valid1 = (this.$refs['basicForm'] as any).validate()
    var valid2 =
      (this.$refs['ruleConfigForm'] as any).rules === null
        ? new Promise((resolver) => resolver(true))
        : (this.$refs['ruleConfigForm'] as any).validate()
    Promise.all([valid1, valid2]).then((values) => {
      let index = values.findIndex((x) => x === false)
      if (index > -1) {
        if (index === 0) this.currentTab = 'basicForm'
        if (index === 1) this.currentTab = 'ruleConfigForm'
      } else {
        if (!this.formItem.rechargeableCoupons.length) {
          this.$Notice.warning({
            title: '优惠券不能为空',
          })
          this.currentTab = 'ruleConfigForm'
          return
        }
        if (!this.activityId && !this.formItem.items.length) {
          this.$Notice.warning({
            title: '卡密不能为空',
          })
          this.currentTab = 'ruleConfigForm'
          return
        }
        console.log('最终数据', this.formItem);
        if (this.activityId) {
          RechargeCardApi.updateProductDetail(this.activityId, this.formItem).then((res) => {
            this.$Message.success('保存成功')
            this.$router.push({
              name: 'rechargeCardCoupon',
            })
          })
        } else {
          RechargeCardApi.createChargeProductCard(this.formItem).then((res) => {
            this.$Message.success('保存成功')
            this.$router.push({
              name: 'rechargeCardCoupon',
            })
          })
        }
      }
    })
  }
  created() {
    if (this.$route.query.id !== undefined) {
      this.activityId = this.$route.query.id.toString()
      this.loadActivity()
    }
  }
  loadActivity() {
    RechargeCardApi.getProductDetail(this.activityId).then((res) => {
      console.log('卡密活动', res)
      this.formItem = res.data
      if(res.data.rechargeableCoupons && res.data.rechargeableCoupons.length) {
        this.selectedItems = res.data.rechargeableCoupons.map(item => item.couponId)
      }
      this.formItem.beginTime = new Date(res.data.beginTime)
      this.formItem.endTime = new Date(res.data.endTime)
    })
  }
  // 下面是商品modal事件
  addProduct() {
    this.getProductData()
    this.isShowSelectProductModal = true
  }
  onSubmit(form) {
    this.getProductData(form)
  }
  // 获取优惠券列表
  getProductList() {
    return this.formItem.rechargeableCoupons
  }
  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }
  // 删除优惠券
  deleteProduct(index) {
    this.formItem.rechargeableCoupons.splice(index, 1)
    this.selectedItems.splice(index, 1)
  }
  getProductData(form = {}) {
    let keyWord = form['keyWord']
    let { pageSize, currentPage } = this.page
    this.loading = true
    CouponApi.getList(pageSize, currentPage, false, keyWord)
      .then((res) => {
        this.loading = false
        if (res.data.items.length) {
          let result = []
          res.data.items.forEach((element) => {
            element['_disabled'] = this.selectedItems.findIndex((x) => x == element.id) > -1
            result.push(element)
          })
          this.page.totalCount = res.data.totalCount
          this.productData = result
        }
      })
      .catch(() => {
        this.loading = false
        this.page.totalCount = 0
        this.productData = []
      })
  }
  // 选择完优惠券
  sureProduct() {
    let selection = (this.$refs.selectioncoupon as any).getSelection()
    if (selection.length) {
      console.log(selection)
      let arr = selection.map((item) => item.id)
      this.selectedItems = this.selectedItems.concat(arr)
      let templateArr = selection.map(item => {
        return {
          couponId: item.id,
          name: item.name,
          count: 1
        }
      })
      this.formItem.rechargeableCoupons = this.formItem.rechargeableCoupons.concat(templateArr)
      this.isShowSelectProductModal = false
    } else {
      this.$Notice.warning({
        title: '请先选择数据',
      })
    }
  }

  pageSizeChange(pageSize) {
    this.page.pageSize = pageSize
    this.page.currentPage = 1
    this.submitFn()
  }
  changePage(currentPage) {
    this.page.currentPage = currentPage
    this.submitFn()
  }
}
